import React from 'react';
import QuoteCard from './QuoteCard';
import Icon from '../../../components/AppIcon';

const QuoteList = ({ quotes, onView, onEdit, onConvert, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12 md:py-16">
        <div className="text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-muted-foreground">Cargando cotizaciones...</p>
        </div>
      </div>
    );
  }

  if (quotes?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 md:py-16 bg-card rounded-lg shadow-elevation-1">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-muted flex items-center justify-center mb-4">
          <Icon name="FileText" size={32} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-2">
          No se encontraron cotizaciones
        </h3>
        <p className="text-sm md:text-base text-muted-foreground text-center max-w-md">
          No hay cotizaciones pendientes que coincidan con los filtros seleccionados
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:gap-6">
      {quotes?.map((quote) => (
        <QuoteCard
          key={quote?.id}
          quote={quote}
          onView={onView}
          onEdit={onEdit}
          onConvert={onConvert}
        />
      ))}
    </div>
  );
};

export default QuoteList;